<script>
import {VerticalCounterCard} from "@/views/statistics/components/index";

export default {
    components: {VerticalCounterCard},
    props: {
        total: {
            default() {
                return {data: 0};
            }
        },
        new: {
            default() {
                return {data: 0};
            }
        },
        replied: {
            default() {
                return {data: 0};
            }
        },
        approved: {
            default() {
                return {data: 0};
            }
        }
    },
    data() {
        return {
            counters: []
        };
    },
    methods: {
        initCounters() {
            this.counters = [];
            this.counters.push({
                key: 'counter.product.requests.sent.total',
                title: this.$t('Component(Statistics):counter.product.requests.sent.total') ,
                avatar: 'ChevronsRightIcon',
                avatarVariant: 'light-primary',
                payment: this.total.data,
                deduction: false,
            });
            let percentage = 0;
            if (this.total.data > 0) {
                percentage = this.calculatePercentage(
                    this.new.data,
                    this.total.data
                );
            }
            this.counters.push({
                key: 'counter.product.requests.sent.new',
                title: this.$t('Component(Statistics):counter.product.requests.sent.new') ,
                description: percentage + '%',
                avatar: 'EyeOffIcon',
                avatarVariant: 'light-danger',
                payment: this.new.data,
                deduction: (this.approved.data + this.replied.data) < this.new.data,
            });
            if (this.total.data > 0) {
                percentage = this.calculatePercentage(
                    this.replied.data,
                    this.total.data
                );
            }
            this.counters.push({
                key: 'counter.product.requests.sent.replied',
                title: this.$t('Component(Statistics):counter.product.requests.sent.replied') ,
                description: percentage + '%',
                avatar: 'BellIcon',
                avatarVariant: 'light-success',
                payment: this.replied.data,
                deduction: false,
            });
            if (this.total.data > 0) {
                percentage = this.calculatePercentage(
                    this.approved.data,
                    this.total.data
                );
            }
            this.counters.push({
                key: 'counter.product.requests.sent.approved',
                title: this.$t('Component(Statistics):counter.product.requests.sent.approved') ,
                description: percentage + '%',
                avatar: 'CheckIcon',
                avatarVariant: 'light-success',
                payment: this.approved.data,
                deduction: false,
            });
        },
        calculatePercentage(amount, total) {
            return Math.round(amount / total * 100 * 100) / 100;
        },
    },
    watch: {
        total() {
            this.initCounters();
        }
    }
}
</script>

<template>
    <VerticalCounterCard
        :label="$t('Component(Statistics):label-product-requests-counters')"
        :counters="counters"
    />
</template>
